// src/api.js
import axios from 'axios';
export const register = async (userData) => {
  return await axios.post(`/auth/register`, userData);
};
export const validateUser = async (userData) => {
  return await axios.post(`/auth/validate-user`, userData);
};
export const login = async (userData) => {
  return await axios.post(`/auth/login`, userData);
};
export const forget_password = async (forgotPasswordData) => {
  return await axios.post(`/auth/forgot-password`, forgotPasswordData);
};
export const reset_password = async (resetPasswordData) => {
  return await axios.post(`/auth/set-password`, resetPasswordData);
};